import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { authSelector } from '../store/slices/authSlice';
import AppLogout from './AppLogout';

const AuthRoutes = () => {

    const authStatus = useSelector(authSelector);
    const token = localStorage.getItem("token");
    const login_status = authStatus.isAuthenticated;
    return (
        token !== null && login_status ? <AppLogout><Outlet /></AppLogout> : <Navigate to="/externalLogin" />
    )
}

export default AuthRoutes;